import React from "react";

const API = () => {
    return (
        <>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <ul className="list-unstyled">
                            <li>
                                <small className="small-text-grey">API Integration Key</small>
                            </li>
                            <li style={{marginTop: 15}}>
                                <div className="input-group">
                                    <input type="text"
                                           className="form-control form-control-lg input-form-alt"
                                           placeholder="Full name"
                                           value={"ZNG-838847-AJJSJ29-8374783-AGGWH"}
                                           disabled={true}
                                           aria-label="Username" aria-describedby="basic-addon1"/>
                                </div>
                            </li>
                            <br/>
                            <li style={{marginTop: 15}}>
                                <hr/>
                            </li>
                            <li>
                                <small className="small-text-grey">Webhook URL</small>
                            </li>
                            <li style={{marginTop: 15}}>
                                <div className="input-group">
                                    <input type="text"
                                           className="form-control form-control-lg input-form-alt"
                                           placeholder="Webhook URL"
                                           aria-label="Username" aria-describedby="basic-addon1"/>
                                </div>
                            </li>
                            <p className="text-left small-text-blue text-right">
                                Update
                            </p>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default API;
